import { Component } from '@angular/core'

@Component({
  selector: 'flo-event-collection-skeleton',
  templateUrl: './event-collection-skeleton.component.html'
})
export class EventCollectionSkeletonComponent {}
